// =============================================================
// APPLICATION CONSTANTS
// =============================================================

export const APP_CONFIG = {
  name: 'Nextgen Health Care Services',
  tagline: 'Authorized Collection Center | Dr Lal PathLabs',
  phone: '0671-2307786',
  email: 'info@nextgen-healthcare.co.in',
  address: 'Manglabag Medical Road, Cuttack, Odisha, India',
  copyrightYear: new Date().getFullYear(),
} as const

export const NAV_LINKS = [
  { label: 'BOOK HOME COLLECTION', href: '#book', id: 'book-home' },
  { label: 'OUR SERVICES',         href: '#services', id: 'services' },
  { label: 'FIND A TEST',          href: '#tests', id: 'tests' },
  { label: 'HEALTH PACKAGES',      href: '#packages', id: 'packages' },
  { label: 'ABOUT US',             href: '#about', id: 'about' },
  { label: 'CONTACT US',           href: '#contact', id: 'contact' },
] as const

export const TOP_NAV_LINKS = [
  { label: 'Investors', href: '#investors', id: 'investors' },
  { label: 'FAQ',       href: '#faq',       id: 'faq' },
  { label: 'Blog',      href: '#blog',      id: 'blog' },
] as const

export const SOCIAL_LINKS = [
  { label: 'Facebook',  href: 'https://facebook.com',  icon: 'facebook'  },
  { label: 'Twitter',   href: 'https://twitter.com',   icon: 'twitter'   },
  { label: 'Instagram', href: 'https://instagram.com', icon: 'instagram' },
  { label: 'YouTube',   href: 'https://youtube.com',   icon: 'youtube'   },
] as const

export const FOOTER_LINKS = {
  quickLinks: [
    { label: 'Home Collection', href: '#book'     },
    { label: 'Health Packages', href: '#packages' },
    { label: 'Find a Test',     href: '#tests'    },
    { label: 'Our Services',    href: '#services' },
    { label: 'About Us',        href: '#about'    },
  ],
  support: [
    { label: 'Contact Us',   href: '#contact'  },
    { label: 'FAQ',          href: '#faq'       },
    { label: 'Privacy Policy', href: '#privacy' },
    { label: 'Terms of Use', href: '#terms'     },
  ],
} as const

